import React from "react";

const Features = ({ features }) => {
  return (
    <section id="features" className="py-16 px-8 bg-gray-50">
      <h3 className="text-3xl font-bold mb-10 text-center text-red-500">
        Features
      </h3>
      <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {features.map((feature, index) => (
          <div key={index} className="bg-white p-6 rounded shadow text-center">
            <div className="text-4xl mb-4">{feature.icon}</div>
            <h4 className="text-xl font-semibold mb-2">{feature.title}</h4>
            <p className="text-gray-600">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Features;
